import { Helmet } from 'react-helmet';

const SITE_URL = 'https://manaraschool.org';

export default function VideoSchema({
  name,
  description,
  thumbnailUrl,
  contentUrl,
  uploadDate,
}) {
  if (!contentUrl) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: name || 'Manara School',
    description: description || 'A World-Class education for exceptional students',
    thumbnailUrl: thumbnailUrl
      ? [thumbnailUrl.startsWith('http') ? thumbnailUrl : `${SITE_URL}${thumbnailUrl}`]
      : [`${SITE_URL}/assets/images/logo.png`],
    contentUrl: contentUrl.startsWith('http') ? contentUrl : `${SITE_URL}${contentUrl}`,
    uploadDate: uploadDate || '2024-01-01',
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
